// extracted by mini-css-extract-plugin
export default {"container":"About_container__7+pZi","about":"About_about__4rL8d","content":"About_content__iFbIK"};